import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, searchValue: string, replaceValue: string): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (!searchValue) {
      return value;
    }

    if (replaceValue === null || replaceValue === undefined) {
      return value;
    }

    return value.replace(new RegExp(searchValue, 'g'), replaceValue);
  }
}